module.exports = __webpack_public_path__ + "static/img/white-fade.6bc2ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white-fade.png
// module id = HYvk
// module chunks = 0